import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Categories, Category } from '../interfaces/category';
import { catchError, map, Observable, throwError } from 'rxjs';
import { BASEURL } from '../constant/url';

@Injectable({
  providedIn: 'root',
})
export class CategoriesService {
  private readonly _http = inject(HttpClient);

  fetchCategories(page: number, pageSize?: number, query?: string): Observable<Categories> {
    let url = `${BASEURL}categories?sort=id:desc&pagination[page]=${page}&pagination[pageSize]=${pageSize || 10}`;
    if (query) {
      url += `&filters[$or][0][name][$containsi]=${encodeURIComponent(query)}`;
    }
    return this._http.get<Categories>(url).pipe(catchError(this.handleError));
  }

  addCategory(data: { data: { name: string } }): Observable<any> {
    return this._http.post<any>(BASEURL + 'categories', data).pipe(catchError(this.handleError));
  }

  deleteCategory(id: number): Observable<any> {
    return this._http.delete<any>(BASEURL + 'categories/' + id).pipe(catchError(this.handleError));
  }

  updateCategory(
    id: number,
    data: { data: { name: string } }
  ): Observable<any> {
    return this._http.put<any>(BASEURL + 'categories/' + id, data).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Error en el servicio de Categorías.';
    if (error.error && error.error.error && error.error.error.message) {
      errorMessage = error.error.error.message;
    } else if (error.message) {
      errorMessage = error.message;
    }
    console.error('CategoriesService error:', errorMessage, error.error || error);
    return throwError(() => new Error(errorMessage));
  }
}
